export const SMALL = 25;
export const MEDIUM = 50;
export const LARGE = 100;
export const X_LARGE = 250;

export const orderedRadii = [SMALL, MEDIUM, LARGE, X_LARGE];
